import { ReactNode } from 'react';

import { Box } from '../../chakra';

export const Main = ({ children }: { children: ReactNode }) => {
  return (
    <Box
      as="main"
      background="gray.25"
      flex="1"
      // Min height makes sure the page fills the viewport
      minHeight="100vh"
      // Max height, so that this component is the scroll container, rather than its parent
      // We need this to allow position: sticky to work inside here while we have overflowX="hidden"
      // We could remove this if we could use overflowX="clip", but safari support is too recent for now
      maxHeight="100vh"
      overflowX="hidden"
      overflowY="auto"
      css={{
        '@supports (overflow: clip)': {
          maxHeight: 'unset',
          overflowX: 'clip',
          overflowY: 'unset',
        },
        _dark: {
          background: 'none',
        },
      }}
    >
      {children}
    </Box>
  );
};
